<div class="fluxo-caixa-container">
  <div class="header d-flex justify-content-between align-items-center flex-wrap gap-2">
    <h1>Fluxo de Caixa</h1>
        <div class="d-flex align-items-center acoes-header flex-wrap">
          <button class="btn btn-outline-primary btn-sm" (click)="alterarAno(-1)">
            <i class="fa fa-chevron-left"></i>
          </button>
          <span class="ano-pill">{{ ano }}</span>
          <button class="btn btn-outline-primary btn-sm" (click)="alterarAno(1)">
            <i class="fa fa-chevron-right"></i>
          </button>
          <button class="btn btn-primary btn-sm" (click)="carregarRelatorio()">
            <i class="fa fa-refresh"></i> Atualizar
          </button>
          <button class="btn btn-success btn-sm btn-exportar-excel" (click)="exportarExcel()">
            <i class="fa fa-file-excel-o"></i> Exportar Excel
          </button>
        </div>
  </div>

  <div
    #tabelaScroll
    class="card-box table-responsive"
        [class.dragging-table]="arrastandoTabela"
        (mousedown)="iniciarArrasteTabela($event, tabelaScroll)"
        (mousemove)="moverArrasteTabela($event, tabelaScroll)"
        (mouseup)="encerrarArrasteTabela()"
    (mouseleave)="encerrarArrasteTabela()">
    <table class="table table-bordered table-sm fluxo-table">
      <ng-template #cabecalhoMesesRef>
        <tr class="linha-cabecalho-meses">
          <th class="conta-col" scope="col">Plano de Contas</th>
          <th *ngFor="let mes of meses" scope="col">{{ mes }}</th>
          <th class="col-total" scope="col">Total</th>
          <th class="col-media" scope="col">Média</th>
          <th class="col-percentual" scope="col">%</th>
        </tr>
      </ng-template>

      <thead>
            <ng-container *ngTemplateOutlet="cabecalhoMesesRef"></ng-container>
          </thead>
          <tbody>
            <tr class="linha-resumo saldo-anterior">
              <td>SALDO ANTERIOR</td>
              <td *ngFor="let item of saldoMes; let i = index">{{ formatMoneyOuTraco(obterSaldoAnteriorMes(i)) }}</td>
              <td class="col-total">{{ formatMoneyOuTraco(saldoAnterior) }}</td>
              <td class="col-media">{{ formatMoneyOuTraco(calcularMedia(saldoAnterior, saldoMes)) }}</td>
              <td class="col-percentual">-</td>
            </tr>

            <tr class="linha-resumo entradas">
              <td>ENTRADAS</td>
              <td *ngFor="let item of totaisEntradas">{{ formatMoneyOuTraco(item) }}</td>
              <td class="col-total">{{ formatMoneyOuTraco(totalEntradas) }}</td>
              <td class="col-media">{{ formatMoneyOuTraco(calcularMedia(totalEntradas, totaisEntradas)) }}</td>
              <td class="col-percentual">{{ formatPercentual(totalEntradas > 0 ? 100 : null) }}</td>
            </tr>

            <ng-container
              *ngTemplateOutlet="linhasTemplate; context: { $implicit: linhas, nivel: 0, naturezaRef: 'ENTRADA', basePercentual: totalEntradas }">
            </ng-container>

            <tr class="linha-resumo saidas">
              <td>SAIDAS</td>
              <td *ngFor="let item of totaisSaidas">{{ formatMoneyOuTraco(item) }}</td>
              <td class="col-total">{{ formatMoneyOuTraco(totalSaidas) }}</td>
              <td class="col-media">{{ formatMoneyOuTraco(calcularMedia(totalSaidas, totaisSaidas)) }}</td>
              <td class="col-percentual">{{ formatPercentual(totalSaidas > 0 ? 100 : null) }}</td>
            </tr>

            <ng-container
              *ngTemplateOutlet="linhasTemplate; context: { $implicit: linhas, nivel: 0, naturezaRef: 'SAIDA', basePercentual: totalSaidas }">
            </ng-container>

            <tr class="linha-resumo saldo-final">
              <td>SALDO FINAL</td>
              <td *ngFor="let valor of saldoMes">{{ formatMoneyOuTraco(valor) }}</td>
              <td class="col-total">{{ formatMoneyOuTraco(saldoFinalTotal) }}</td>
              <td class="col-media">{{ formatMoneyOuTraco(calcularMedia(saldoFinalTotal, saldoMes)) }}</td>
              <td class="col-percentual">-</td>
            </tr>

            <ng-container *ngTemplateOutlet="cabecalhoMesesRef"></ng-container>

            <tr class="linha-totalizador receitas-resumo">
              <td>Receitas</td>
              <td *ngFor="let valor of totaisReceitas">{{ formatMoneyOuTraco(valor) }}</td>
              <td class="col-total">{{ formatMoneyOuTraco(totalReceitas) }}</td>
              <td class="col-media">{{ formatMoneyOuTraco(calcularMedia(totalReceitas, totaisReceitas)) }}</td>
              <td class="col-percentual">-</td>
            </tr>

            <tr class="linha-totalizador despesas-resumo">
              <td>Despesas</td>
              <td *ngFor="let valor of despesasResumo">{{ formatMoneyOuTraco(valor) }}</td>
              <td class="col-total">{{ formatMoneyOuTraco(totalDespesasResumo) }}</td>
              <td class="col-media">{{ formatMoneyOuTraco(calcularMedia(totalDespesasResumo, despesasResumo)) }}</td>
              <td class="col-percentual">-</td>
            </tr>

            <tr class="linha-totalizador resultado-mensal">
              <td>Resultado Mensal</td>
              <td *ngFor="let valor of resultadoMensal">{{ formatMoneyOuTraco(valor) }}</td>
              <td class="col-total">{{ formatMoneyOuTraco(totalResultadoMensal) }}</td>
              <td class="col-media">{{ formatMoneyOuTraco(calcularMedia(totalResultadoMensal, resultadoMensal)) }}</td>
              <td class="col-percentual">-</td>
            </tr>

            <tr class="linha-totalizador lucratividade-resumo">
              <td>Lucratividade Financeira</td>
              <td *ngFor="let valor of lucratividadeResumo">{{ formatLucratividadeResumo(valor) }}</td>
              <td class="col-total">{{ formatLucratividadeResumo(totalReceitas > 0 ? totalResultadoMensal / totalReceitas : null) }}</td>
              <td class="col-media">{{ formatLucratividadeResumo(mediaLucratividadeResumo) }}</td>
              <td class="col-percentual">-</td>
            </tr>

            <tr class="linha-totalizador receita-ano-anterior">
              <td>Receita {{ ano - 1 }}</td>
              <td *ngFor="let valor of totaisReceitasAnoAnterior">{{ formatMoneyOuTraco(valor) }}</td>
              <td class="col-total">{{ formatMoneyOuTraco(totalReceitaAnoAnterior) }}</td>
              <td class="col-media">{{ formatMoneyOuTraco(calcularMedia(totalReceitaAnoAnterior, totaisReceitasAnoAnterior)) }}</td>
              <td class="col-percentual">-</td>
            </tr>
      </tbody>
    </table>
  </div>

  <!-- Distribuição de lucros / sócios (regras planilha FC) -->
  <div class="card-box socios-distribuicao-section" *ngIf="mostrarDistribuicaoSocios">
    <div class="socios-cabecalho d-flex justify-content-between align-items-start flex-wrap">
      <div>
        <h2 class="socios-titulo">Distribuição de Lucros e Sócios</h2>
        <p class="socios-subtitulo text-muted mb-0">
          Retirada reserva = Salários ÷ 12 · Participação = Resultado Mensal − Retirada reserva · Saldos conforme planilha FC
        </p>
      </div>
      <button type="button" class="btn btn-sm btn-outline-secondary mt-1" (click)="salvarSociosStorage()">
        <i class="fa fa-save"></i> Salvar dados
      </button>
    </div>

    <div class="socios-config row mb-3">
      <div class="col-md-8">
        <div class="table-responsive">
          <table class="table table-sm table-bordered socios-config-table mb-0">
            <thead>
              <tr>
                <th>Sócio</th>
                <th>% Participação</th>
                <th>Saldo Inicial (jan)</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let socio of socios; let i = index; trackBy: trackByIndex">
                <td>
                  <input type="text" class="form-control form-control-sm" [(ngModel)]="socio.nome" (ngModelChange)="onSociosInputChange()">
                </td>
                <td>
                  <div class="input-group input-group-sm">
                    <input
                      type="number"
                      class="form-control form-control-sm"
                      step="0.01"
                      [ngModel]="socio.percentual * 100"
                      (ngModelChange)="onPercentualSocioChange(i, $event)">
                    <div class="input-group-append"><span class="input-group-text">%</span></div>
                  </div>
                </td>
                <td>
                  <input
                    type="number"
                    class="form-control form-control-sm text-right"
                    step="0.01"
                    [(ngModel)]="socio.saldoInicial"
                    (ngModelChange)="onSociosInputChange()">
                </td>
              </tr>
              <tr class="linha-reserva-config">
                <td colspan="2"><strong>Reserva — saldo inicial</strong></td>
                <td>
                  <input
                    type="number"
                    class="form-control form-control-sm text-right"
                    step="0.01"
                    [(ngModel)]="reservaSaldoInicial"
                    (ngModelChange)="onSociosInputChange()">
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div
      #sociosScroll
      class="table-responsive socios-table-wrap"
      [class.dragging-table]="arrastandoTabela"
      (mousedown)="iniciarArrasteTabela($event, sociosScroll)"
      (mousemove)="moverArrasteTabela($event, sociosScroll)"
      (mouseup)="encerrarArrasteTabela()"
      (mouseleave)="encerrarArrasteTabela()">
      <table class="table table-bordered table-sm socios-table">
        <thead>
          <tr>
            <th class="conta-col">Descrição</th>
            <th *ngFor="let mes of mesesCabecalhoSocios; trackBy: trackByIndex">{{ mes }}</th>
          </tr>
        </thead>
        <tbody>
          <!-- Retirada reserva / Participação -->
          <tr class="sec-topo">
            <td class="conta-col"><strong>Retirada reserva</strong></td>
            <td *ngFor="let _ of mesesCabecalhoSocios; let i = index; trackBy: trackByIndex">
              <input
                type="number"
                class="form-control form-control-sm input-valor"
                step="0.01"
                [ngModel]="calcMes(i)?.retiradaReserva"
                (ngModelChange)="setRetiradaReservaManual(i, $event)"
                title="Automático: Salários÷12. Edite para fixar; limpe com o botão Auto.">
              <button
                type="button"
                class="btn-auto"
                *ngIf="sociosMesInputs[i]?.retiradaReservaManual != null"
                (click)="limparOverrideRetiradaReserva(i)"
                title="Voltar ao automático (Salários÷12)">Auto</button>
            </td>
          </tr>
          <tr class="sec-topo participacao-row">
            <td class="conta-col"><strong>Participação dos Lucros</strong></td>
            <td *ngFor="let _ of mesesCabecalhoSocios; let i = index; trackBy: trackByIndex">
              <input
                type="number"
                class="form-control form-control-sm input-valor text-danger"
                step="0.01"
                [ngModel]="calcMes(i)?.participacao"
                (ngModelChange)="setParticipacaoManual(i, $event)">
              <button
                type="button"
                class="btn-auto"
                *ngIf="sociosMesInputs[i]?.participacaoManual != null"
                (click)="limparOverrideParticipacao(i)"
                title="Voltar ao automático (Resultado − Reserva)">Auto</button>
            </td>
          </tr>

          <!-- Saldo Anterior -->
          <tr class="sec-header sec-saldo-ant">
            <td class="conta-col" [attr.colspan]="1 + mesesCabecalhoSocios.length">Saldo Anterior</td>
          </tr>
          <tr *ngFor="let socio of socios; let s = index; trackBy: trackByIndex">
            <td class="conta-col">
              {{ socio.nome }}
              <span class="pct-badge">{{ socio.percentual * 100 | number:'1.2-2' }}%</span>
            </td>
            <td *ngFor="let _ of mesesCabecalhoSocios; let i = index; trackBy: trackByIndex">
              {{ formatMoneyNullable(calcMes(i)?.saldoAnterior[s]) }}
            </td>
          </tr>
          <tr class="linha-reserva">
            <td class="conta-col">Reserva</td>
            <td *ngFor="let _ of mesesCabecalhoSocios; let i = index; trackBy: trackByIndex">
              {{ formatMoneyNullable(calcMes(i)?.saldoAnterior[4]) }}
            </td>
          </tr>

          <!-- Distribuição de Lucros -->
          <tr class="sec-header sec-dist">
            <td class="conta-col" [attr.colspan]="1 + mesesCabecalhoSocios.length">Distribuição de Lucros</td>
          </tr>
          <tr *ngFor="let socio of socios; let s = index; trackBy: trackByIndex">
            <td class="conta-col">
              {{ socio.nome }}
              <span class="pct-badge">{{ socio.percentual * 100 | number:'1.2-2' }}%</span>
            </td>
            <td *ngFor="let _ of mesesCabecalhoSocios; let i = index; trackBy: trackByIndex">
              {{ formatMoneyNullable(calcMes(i)?.distribuicao[s]) }}
            </td>
          </tr>

          <!-- Retiradas -->
          <tr class="sec-header sec-ret">
            <td class="conta-col" [attr.colspan]="1 + mesesCabecalhoSocios.length">Retiradas</td>
          </tr>
          <tr *ngFor="let socio of socios; let s = index; trackBy: trackByIndex">
            <td class="conta-col">{{ socio.nome }}</td>
            <td *ngFor="let _ of mesesCabecalhoSocios; let i = index; trackBy: trackByIndex">
              <input
                type="number"
                class="form-control form-control-sm input-valor"
                step="0.01"
                [ngModel]="calcMes(i)?.retiradas[s]"
                (ngModelChange)="setRetiradaManual(i, s, $event)">
              <button
                type="button"
                class="btn-auto"
                *ngIf="sociosMesInputs[i]?.retiradasManual[s] != null"
                (click)="limparOverrideRetirada(i, s)">Auto</button>
            </td>
          </tr>

          <!-- Aluguel -->
          <tr class="sec-header sec-aluguel">
            <td class="conta-col" [attr.colspan]="1 + mesesCabecalhoSocios.length">Aluguel Sala Claudia Distribuição</td>
          </tr>
          <tr>
            <td class="conta-col"><strong>Valor</strong></td>
            <td *ngFor="let _ of mesesCabecalhoSocios; let i = index; trackBy: trackByIndex">
              <input
                type="number"
                class="form-control form-control-sm input-valor"
                step="0.01"
                [ngModel]="sociosMesInputs[i]?.aluguelValor"
                (ngModelChange)="setAluguelValor(i, $event)">
            </td>
          </tr>
          <tr *ngFor="let socio of socios; let s = index; trackBy: trackByIndex">
            <td class="conta-col">
              {{ socio.nome }}
              <span class="pct-badge">{{ socio.percentual * 100 | number:'1.2-2' }}%</span>
            </td>
            <td *ngFor="let _ of mesesCabecalhoSocios; let i = index; trackBy: trackByIndex">
              {{ formatMoneyNullable(calcMes(i)?.aluguelSocio[s]) }}
            </td>
          </tr>

          <!-- Outros ajustes -->
          <tr class="sec-header sec-ajustes">
            <td class="conta-col" [attr.colspan]="1 + mesesCabecalhoSocios.length">
              Outros ajustes (informar o ajuste e se é negativo ou positivo)
            </td>
          </tr>
          <tr *ngFor="let aj of [0,1,2,3]; trackBy: trackByIndex">
            <td class="conta-col">
              <input
                type="text"
                class="form-control form-control-sm"
                [ngModel]="labelAjuste(aj)"
                (ngModelChange)="setAjusteLabel(aj, $event)"
                placeholder="Descrição do ajuste">
            </td>
            <td *ngFor="let _ of mesesCabecalhoSocios; let i = index; trackBy: trackByIndex">
              <input
                type="number"
                class="form-control form-control-sm input-valor"
                step="0.01"
                [ngModel]="sociosMesInputs[i]?.ajustes[aj]?.valor"
                (ngModelChange)="setAjusteValor(i, aj, $event)"
                title="Use valor negativo para débito">
            </td>
          </tr>

          <!-- Saldo Atual -->
          <tr class="sec-header sec-saldo-atual">
            <td class="conta-col" [attr.colspan]="1 + mesesCabecalhoSocios.length">Saldo Atual</td>
          </tr>
          <tr *ngFor="let socio of socios; let s = index; trackBy: trackByIndex">
            <td class="conta-col">{{ socio.nome }}</td>
            <td *ngFor="let _ of mesesCabecalhoSocios; let i = index; trackBy: trackByIndex">
              {{ formatMoneyNullable(calcMes(i)?.saldoAtual[s]) }}
            </td>
          </tr>
          <tr class="linha-reserva-atual">
            <td class="conta-col">Reserva</td>
            <td *ngFor="let _ of mesesCabecalhoSocios; let i = index; trackBy: trackByIndex">
              {{ formatMoneyNullable(calcMes(i)?.saldoAtual[4]) }}
            </td>
          </tr>

          <tr class="linha-lucros-retidos">
            <td class="conta-col"><strong>Saldo atual Lucros retidos</strong></td>
            <td *ngFor="let _ of mesesCabecalhoSocios; let i = index; trackBy: trackByIndex">
              {{ formatMoneyNullable(calcMes(i)?.lucrosRetidos) }}
            </td>
          </tr>
          <tr class="linha-saldo-caixa">
            <td class="conta-col"><strong>Saldo atual Caixa</strong></td>
            <td *ngFor="let _ of mesesCabecalhoSocios; let i = index; trackBy: trackByIndex">
              {{ formatMoneyOuTraco(saldoMes[i]) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="card-box indicadores-section">
    <div class="indicadores-cabecalho">
      <div class="indicadores-cabecalho-texto">
        <span class="indicadores-titulo">Indicadores Cidadania</span>
        <span class="indicadores-subtitulo">Consulte gráficos e análises financeiras do ano selecionado</span>
      </div>
      <div class="indicadores-cabecalho-acoes">
        <span class="competencia-badge" *ngIf="nomeMesCompetencia">
          <i class="fa fa-calendar"></i> {{ nomeMesCompetencia }}/{{ ano }}
        </span>
        <button type="button" class="btn btn-sm btn-outline-primary" (click)="abrirSelecaoCompetencia()">
          <i class="fa fa-calendar-check-o"></i> Mês de competência
        </button>
      </div>
    </div>
    <div class="indicadores-grid">
      <button
        type="button"
        class="btn btn-sm btn-outline-primary indicador-chip"
        *ngFor="let item of indicadores"
        (click)="abrirIndicador(item.id)">
        <i class="fa" [ngClass]="obterIconeIndicador(item.id)"></i>
        {{ item.titulo }}
      </button>
    </div>
  </div>
</div>

<ng-template #linhasTemplate let-nos let-nivel="nivel" let-naturezaRef="naturezaRef" let-basePercentual="basePercentual">
  <ng-container *ngFor="let item of nos">
    <tr
      *ngIf="(item.natureza || '').toUpperCase() === naturezaRef"
      [class.sintetica]="isSintetica(item)"
      [class.linha-grupo]="isSintetica(item) && hasFilhos(item)">
      <td class="conta-col">
        <div class="conta-cell" [style.padding-left.px]="8 + (nivel * 20)">
          <button *ngIf="hasFilhos(item)" type="button" class="btn-toggle" (click)="toggle(item)">
            {{ isExpandido(item) ? '−' : '+' }}
          </button>
          <span *ngIf="!hasFilhos(item)" class="leaf-dot">•</span>
          <span class="conta-text">{{ item.codigo }} {{ item.nome }}</span>
        </div>
      </td>
      <td *ngFor="let valor of item.valores">{{ formatMoneyOuTraco(valor) }}</td>
      <td class="col-total">{{ formatMoneyOuTraco(item.total) }}</td>
      <td class="col-media">{{ formatMoneyOuTraco(calcularMediaLinha(item)) }}</td>
      <td class="col-percentual">{{ formatPercentual(calcularPercentualLinha(item, basePercentual)) }}</td>
    </tr>

    <ng-container *ngIf="hasFilhos(item) && isExpandido(item)">
      <ng-container
        *ngTemplateOutlet="linhasTemplate; context: { $implicit: item.filhos, nivel: nivel + 1, naturezaRef: naturezaRef, basePercentual: item.total }">
      </ng-container>
    </ng-container>
  </ng-container>
</ng-template>

<!-- Modal competência -->
<div class="indicador-modal-overlay" *ngIf="modalCompetenciaAberto" (click)="fecharSelecaoCompetencia()">
  <div class="indicador-modal-box indicador-modal-box-sm" (click)="$event.stopPropagation()">
    <h4>Seleção do mês de competência</h4>
    <p class="text-muted mb-3">Usado nos gráficos de pizza e referência temporal dos indicadores.</p>
    <div class="mb-3">
      <label class="form-label">Mês</label>
      <select class="form-control" [(ngModel)]="mesCompetencia">
        <option *ngFor="let mes of meses; let i = index" [ngValue]="i + 1">{{ mes }}</option>
      </select>
    </div>
    <div class="indicador-modal-acoes">
      <button type="button" class="btn btn-outline-secondary btn-sm" (click)="fecharSelecaoCompetencia()">Cancelar</button>
      <button type="button" class="btn btn-success btn-sm" (click)="confirmarCompetencia()">Confirmar</button>
    </div>
  </div>
</div>

<!-- Modal indicador -->
<div class="indicador-modal-overlay" *ngIf="indicadorAtivo" (click)="fecharIndicador()">
  <div class="indicador-modal-box indicador-modal-box-lg" (click)="$event.stopPropagation()">
    <div class="indicador-modal-topo">
      <div>
        <h4>Resultados dos indicadores</h4>
        <p class="indicador-modal-subtitulo mb-0">{{ indicadorAtivo.subtitulo }}</p>
      </div>
      <button type="button" class="btn btn-sm btn-outline-secondary" (click)="fecharIndicador()">
        <i class="fa fa-times"></i> Fechar
      </button>
    </div>

    <div class="indicador-modal-corpo">
      <div class="indicador-info-lateral">
        <div class="indicador-info-item">
          <span class="label">Indicador</span>
          <strong>{{ indicadorAtivo.titulo }}</strong>
        </div>
        <div class="indicador-info-item" *ngIf="indicadorAtivo.visual !== 'pizza'">
          <span class="label">Média {{ ano }}</span>
          <strong>{{ formatValorIndicador(indicadorAtivo.mediaAno, indicadorAtivo.formato) }}</strong>
        </div>
      </div>

      <div class="alert alert-light border mb-0" *ngIf="indicadorAtivo.visual === 'pizza' && !indicadorAtivo.seriesPizza?.length">
        Sem movimentação no mês de competência selecionado para montar o gráfico.
      </div>

      <div class="indicador-chart-wrap" *ngIf="exibirGraficoIndicador && indicadorAtivo.chartConfig && indicadorAtivo.chartId">
        <app-apex-chart [chartID]="indicadorAtivo.chartId" [chartConfig]="indicadorAtivo.chartConfig"></app-apex-chart>
      </div>

      <div class="table-responsive indicador-tabela-wrap" *ngIf="indicadorAtivo.visual === 'pizza' && indicadorAtivo.seriesPizza?.length">
        <table class="table table-sm table-bordered indicador-tabela">
          <thead>
            <tr>
              <th>Tipo</th>
              <th class="text-end">{{ indicadorAtivo.colunaValor }} ({{ nomeMesCompetencia }})</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let serie of indicadorAtivo.seriesPizza">
              <td>{{ serie.label }}</td>
              <td class="text-end">{{ formatValorIndicador(serie.total, indicadorAtivo.formato) }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="table-responsive indicador-tabela-wrap" *ngIf="indicadorAtivo.visual !== 'pizza'">
        <table class="table table-sm table-bordered indicador-tabela">
          <thead>
            <tr>
              <th>Mês</th>
              <th class="text-end">{{ indicadorAtivo.colunaValor }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let mes of mesesAbrev; let i = index" [class.mes-competencia]="i + 1 === mesCompetencia">
              <td>{{ mes }}</td>
              <td class="text-end">{{ formatValorIndicador(indicadorAtivo.valoresMensais[i], indicadorAtivo.formato) }}</td>
            </tr>
            <tr class="linha-media">
              <td>Média {{ ano }}</td>
              <td class="text-end">{{ formatValorIndicador(indicadorAtivo.mediaAno, indicadorAtivo.formato) }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="indicador-pdca">
        <div class="indicador-pdca-cabecalho">
          <div class="indicador-pdca-titulo">Acompanhamento (PDCA)</div>
          <small class="text-muted">Indicador: {{ indicadorAtivo.titulo }} · Ano {{ ano }}</small>
        </div>
        <div class="indicador-pdca-toolbar">
          <button type="button" class="btn btn-sm btn-outline-primary" (click)="adicionarLinhaPdca()" [disabled]="salvandoPdca">
            <i class="fas fa-plus"></i> Adicionar linha
          </button>
          <button type="button" class="btn btn-sm btn-primary" (click)="salvarPdcaIndicador()" [disabled]="salvandoPdca || carregandoPdca">
            <i class="fas fa-save"></i> Salvar PDCA
          </button>
        </div>
        <div class="table-responsive indicador-pdca-tabela-wrap">
          <table class="table table-sm table-bordered indicador-pdca-tabela">
            <thead>
              <tr>
                <th class="col-mes">Mês/Período</th>
                <th class="col-fato">Fato</th>
                <th class="col-causa">Causa</th>
                <th class="col-acao">Ação de melhoria</th>
                <th class="col-responsavel">Responsável</th>
                <th class="col-prazo">Prazo</th>
                <th class="col-acoes"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="carregandoPdca">
                <td colspan="7" class="text-muted text-center">Carregando acompanhamento PDCA...</td>
              </tr>
              <tr *ngFor="let linha of pdcaItens; let i = index">
                <td class="col-mes">
                  <select class="form-control form-control-sm" [(ngModel)]="linha.mesPeriodo">
                    <option value="">Selecione...</option>
                    <option *ngFor="let op of opcoesMesPeriodoPdca" [value]="op">{{ op }}</option>
                  </select>
                </td>
                <td class="col-fato">
                  <textarea class="form-control form-control-sm" rows="2" [(ngModel)]="linha.fato" placeholder="Fato"></textarea>
                </td>
                <td class="col-causa">
                  <textarea class="form-control form-control-sm" rows="2" [(ngModel)]="linha.causa" placeholder="Causa"></textarea>
                </td>
                <td class="col-acao">
                  <textarea class="form-control form-control-sm" rows="2" [(ngModel)]="linha.acaoMelhoria" placeholder="Ação de melhoria"></textarea>
                </td>
                <td class="col-responsavel">
                  <input type="text" class="form-control form-control-sm" [(ngModel)]="linha.responsavel" placeholder="Responsável">
                </td>
                <td class="col-prazo">
                  <input type="date" class="form-control form-control-sm" [(ngModel)]="linha.prazo">
                </td>
                <td class="col-acoes text-center">
                  <button type="button" class="btn btn-link btn-sm text-danger p-0" title="Remover" (click)="removerLinhaPdca(i)" [disabled]="salvandoPdca">
                    <i class="fas fa-trash-alt"></i>
                  </button>
                </td>
              </tr>
              <tr *ngIf="!carregandoPdca && pdcaItens.length === 0">
                <td colspan="7" class="text-muted text-center">
                  Nenhum registro PDCA. Use <strong>Adicionar linha</strong> para incluir análises do período.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>